import { render } from "./Gen1.vue?vue&type=template&id=d3203d78&scoped=true"
import script from "./Gen1.vue?vue&type=script&lang=js"
export * from "./Gen1.vue?vue&type=script&lang=js"

import "./Gen1.vue?vue&type=style&index=0&id=d3203d78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3203d78"]])

export default __exports__